import { type ReactNode } from 'react'
import { Icon, type IconName } from '@/icons/Icon'

/**
 * ホーム画面の統計カード。design/js/components.jsx:146-152 を移植。
 *
 * deltaTone: 'pos' (緑) | 'neg' (赤) | 'neu' (グレー、既定相当)。
 * 数値以外も value/delta に渡せるよう ReactNode で受ける。
 */
export type DeltaTone = 'pos' | 'neg' | 'neu'

/** コーナーアイコンの配色 (tint chip)。未指定はニュートラル (グレー)。 */
export type StatIconTone = 'blue' | 'green' | 'amber' | 'red'

export interface StatCardProps {
  label: ReactNode
  value: ReactNode
  delta?: ReactNode
  deltaTone?: DeltaTone
  ico?: IconName
  iconTone?: StatIconTone
}

export const StatCard = ({
  label,
  value,
  delta,
  deltaTone,
  ico,
  iconTone,
}: StatCardProps): JSX.Element => (
  <div className="stat-card">
    <div className="l">
      <span>{label}</span>
      {ico && (
        <span className={`l-ico${iconTone ? ` is-${iconTone}` : ''}`}>
          <Icon name={ico} />
        </span>
      )}
    </div>
    <div className="v">{value}</div>
    {delta != null && <div className={`delta${deltaTone ? ` ${deltaTone}` : ''}`}>{delta}</div>}
  </div>
)
